import { cardApi } from "@/core/data/api";

export default async (id) => {
  return await cardApi.getCardDetail(id);
};
